// tslint:disable:object-literal-sort-keys
import React from "react";

import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core/styles";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import LayersIcon from "@material-ui/icons/Layers";

import { useLocation } from "react-router";
import { Link as RouterLink } from "react-router-dom";

import GlobalDatePicker from "./global-date-picker";
import GlobalPanelPicker from "./global-panel-picker";

import WidgetGridContainer from "./widget-grid-container";

import { useAuth } from "./use-auth";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
  })
);

interface Props {
  entity: { [key: string]: any };
}

function DashboardDetail(props: Props) {
  const theme = useTheme() as Theme;
  const fullWidth = useMediaQuery(theme.breakpoints.down("xs"));

  const location = useLocation();

  const { entity } = props;
  const classes = useStyles(props);

  const { signedIn, hasAnyPermission } = useAuth();

  React.useEffect(() => {
    if (localStorage) {
      localStorage.setItem("lastUrl", location.pathname);
    }
  });

  let showGlobalPanelPicker = false;
  if (entity && entity.widgets) {
    showGlobalPanelPicker = entity.widgets.some(
      (widget: any) => !widget.panelId
    );
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid justify="space-between" alignItems="center" container>
          <Grid item>
            <Typography variant="h5">{entity && entity.title}</Typography>
          </Grid>
          <Grid item>
            <GlobalDatePicker />
          </Grid>
          {showGlobalPanelPicker && (
            <Grid item xs={fullWidth ? 12 : "auto"}>
              <GlobalPanelPicker />
            </Grid>
          )}
          <Grid item>
            <Hidden mdDown>
              {signedIn && hasAnyPermission(["PANEL_WRITE"]) && (
                <Button
                  startIcon={<EditIcon />}
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={`${location.pathname}/edit`}
                >
                  Edit
                </Button>
              )}
              {signedIn && hasAnyPermission(["PANEL_WRITE"]) && (
                <Button
                  startIcon={<LayersIcon />}
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={`${location.pathname}/duplicate`}
                >
                  Duplicate
                </Button>
              )}
              {signedIn && hasAnyPermission(["PANEL_WRITE"]) && (
                <Button
                  startIcon={<DeleteIcon />}
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={`${location.pathname}/delete`}
                >
                  Delete
                </Button>
              )}
            </Hidden>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {entity && (
          <WidgetGridContainer
            entity={entity}
            arrayHelpers={entity.widgets}
            fields={entity.widgets}
            readonly={true}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default DashboardDetail;
